import React from 'react';
import PreferencesManager from './PreferencesManager';

const ManagePreferences = () => {
  return <PreferencesManager />;
};

export default ManagePreferences;
